import { z } from "zod";
import { adminOperationsControlSchemaVersionSchema, adminOperatorIdSchema, adminReasonCodeSchema, adminUlidSchema, } from "./admin-operations-core.js";
import { supportTicketCategorySchema, supportTicketCustomerStateSchema, supportTicketMessageSchema, } from "./customer-operations-support.js";
import { customerOperationsOpaqueIdSchema } from "./customer-operations-core.js";
export const adminSupportQueueStateSchema = z.union([
    supportTicketCustomerStateSchema,
    z.literal("OPEN"),
]);
export const adminSupportQueueCommandSchema = z
    .object({
    state: adminSupportQueueStateSchema.default("OPEN"),
    limit: z.number().int().positive().max(100).default(50),
    query: z.string().trim().max(100).optional(),
    /** The next page: requests that entered their queue before this point (2026-10-21). */
    before: z
        .string()
        .max(160)
        .regex(/^\d{4}-\d{2}-\d{2}T[0-9:.]+Z#[A-Za-z0-9_-]{1,128}$/u)
        .optional(),
})
    .strict();
export const adminSupportQueueSummarySchema = z
    .object({
    ticketId: customerOperationsOpaqueIdSchema,
    category: supportTicketCategorySchema,
    state: supportTicketCustomerStateSchema,
    receivedAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    assignedOperatorId: adminOperatorIdSchema.optional(),
    hasBookContext: z.boolean(),
    customerName: z.string().min(1).max(160).optional(),
    bookTitle: z.string().min(1).max(240).optional(),
    test: z.boolean(),
    operationsEventState: z.enum(["PENDING_DELIVERY", "PUBLISHED", "NEEDS_ATTENTION"]),
})
    .strict();
export const adminSupportQueueResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminOperationsControlSchemaVersionSchema,
        state: adminSupportQueueStateSchema,
        tickets: z.array(adminSupportQueueSummarySchema).max(100),
        truncated: z.boolean(),
        /** When more requests exist: the `before` of the next page. */
        nextBefore: z.string().max(160).optional(),
        examined: z.number().int().nonnegative().max(100).optional(),
    })
        .strict(),
})
    .strict();
export const adminSupportTransitionActionSchema = z.enum([
    "ASSIGN_SELF",
    "START_REVIEW",
    "WAIT_FOR_CUSTOMER",
    "RESOLVE",
    "REOPEN_REVIEW",
]);
export const adminSupportTransitionCommandSchema = z
    .object({
    caseId: adminUlidSchema,
    expectedVersion: z.number().int().positive(),
    action: adminSupportTransitionActionSchema,
    reasonCode: adminReasonCodeSchema,
    customerMessage: supportTicketMessageSchema.optional(),
})
    .strict()
    .superRefine((command, context) => {
    if (["WAIT_FOR_CUSTOMER", "RESOLVE"].includes(command.action) && !command.customerMessage)
        context.addIssue({
            code: "custom",
            path: ["customerMessage"],
            message: "A customer-visible message is required for this transition.",
        });
    if (!["WAIT_FOR_CUSTOMER", "RESOLVE"].includes(command.action) && command.customerMessage)
        context.addIssue({
            code: "custom",
            path: ["customerMessage"],
            message: "This transition does not accept a customer-visible message.",
        });
});
export const adminSupportTransitionResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminOperationsControlSchemaVersionSchema,
        ticketId: customerOperationsOpaqueIdSchema,
        state: supportTicketCustomerStateSchema,
        version: z.number().int().positive(),
        notificationState: z.enum(["NOT_REQUESTED", "SENT", "NEEDS_ATTENTION"]),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-operations-support.js.map